<template>
  <div>
    <span>มียอดเงินใน Balance <b-link :to="{ name: 'finance-balance'}" :class="this.baht >= 0 ? 'text-success' : 'text-danger'">{{format_price(this.baht)}}</b-link> บาท </span>
    <!-- <br>
    <span>มียอดเงินหยวนใน Balance <b-link :to="{ name: 'finance-balance', params: { tabsIndex: 1 }}" :class="this.yuan >= 0 ? 'text-success' : 'text-danger'">{{format_price(this.yuan)}}</b-link> หยวน </span> -->
    <br>
    <small>ยอดที่รอตรวจสอบ {{format_price(this.pendingBalance)}} บาท</small>
  </div>
</template>

<script>
import { format_price } from '@/views/global_function.js'
import { BLink } from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import {header_token, specify_header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  name: 'Taobao2youBalance',

  components: { BLink },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      baht: null,
      yuan: null,
      pendingBalance: null,
      seeExchangeRate: false
    };
  },

  watch:{
    async $route (to, from){
      // await this.isSeeExchange()
      this.loadBalance()
    }
  },

  async created() {
    // await this.isSeeExchange()
    this.loadBalance()
  },

  methods: {
    format_price,
    async loadBalance () {
      var keepdata = []
      var errStatus = null
      var id = await this.userData.data.customerInfo.loginToken
      var axios = require('axios');
      var config = {
        method: 'get',
        url: taobaoService_dotnet + 'app/Balance/get-customer-balance?LoginToken=' + id,
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('auth_token'),
          'Content-Type': 'application/json'
        }
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
        errStatus = error.response.status
      });
      if (errStatus) {
        await this.autoLogout()
        return
      }
      this.baht = keepdata.balanceBaht
      this.yuan = keepdata.balanceYuan
      this.pendingBalance = keepdata.pendingBalanceBaht
      localStorage.setItem('all_balance', JSON.stringify(keepdata))
    },

    async isSeeExchange() {
      let response = await axios.post(
        taobaoService_dotnet  + 'app/Customer/see-exchange-rate',
        {
          "loginToken": this.userData.data.customerInfo.loginToken
        },
        { headers: header_token }
      )
      this.seeExchangeRate = response.data
      localStorage.setItem('isSeeExchangeRate', JSON.stringify(response.data))
    },

    autoLogout() {
      // Remove userData from localStorage
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      localStorage.removeItem('userData')
      localStorage.removeItem('cusId')
      localStorage.removeItem('all_balance')
      localStorage.removeItem("postcode")
      localStorage.removeItem("category")
      localStorage.removeItem("toPath")
      localStorage.removeItem("taobaoReceiveName")
      localStorage.removeItem('adminId')
      localStorage.removeItem('isSeeExchangeRate')
      localStorage.removeItem('ship_type')
      localStorage.removeItem('makeBox_list')
      localStorage.removeItem('tokenAuto')
      localStorage.removeItem('product_link')
      localStorage.removeItem('orderidAuto')
      localStorage.removeItem('order_type')
      localStorage.removeItem('list_item')
      localStorage.removeItem('total_quantity')
      localStorage.removeItem('total_yuan')
      localStorage.removeItem('allTrackingShipping')
      localStorage.removeItem('show_announce')
      localStorage.removeItem('resFacebook')
      localStorage.removeItem('exchange_rate')
      localStorage.removeItem('auth_token')

      localStorage.removeItem('auto-topup')

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
     this.$router.push({ name: 'auth-login' })
    }
  },
};
</script>

<style>
.vl {
  border-left: 1px solid ;
  height: 500px;
}
</style>